/*
 * @Description: 
 */
const Utils = {
    initRem: function () {
        this._fixRem()
        window.addEventListener('resize', this._fixRem, false)
    },
    browser: function () {
        let u = navigator.userAgent,
            versions = { //移动终端浏览器版本信息
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/) || u.indexOf('iPad') > -1, //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
            };
        if (versions.iPhone) {
            sessionStorage.browser = 'IOS'
        } else if (versions.android) {
            sessionStorage.browser = 'AN'
        }
    },
    _fixRem: function () {
        let windowWidth =
            document.documentElement.clientWidth ||
            window.innerWidth ||
            document.body.clientWidth
        windowWidth = windowWidth > 800 ? 800 : windowWidth
        window.rootSize = 25 * (windowWidth / 375)
        let htmlNode = document.getElementsByTagName('html')[0]
        htmlNode.style.fontSize = window.rootSize + 'px'
    },



}

export default Utils
